<template>
    <div id="header" class="d-flex justify-content-between"
        style="border-bottom: solid 1px #ccc; box-shadow: 0 6px 4px -1px rgb(216, 216, 216);">
        <div class="img-header">
            <router-link to="/home">
                <img alt="AngerPulse logo mini" class="p-2 imgHome" style="height: 60px; cursor: pointer;"
                    v-if="showImage" @click="$router.push({ name: 'Home' })" src="../assets/btnAngerPulseHeader.png">
            </router-link>
        </div>
        <div class="menu-header d-flex">
            <div class="m-auto">
                <label class="" style="cursor: pointer;" @click="$i18n.locale = 'en'">
                    <!-- <img src="../assets/Flag_UK.svg" alt="English"
                        style="width: 20px; vertical-align: middle; margin-right: 5px;"> -->
                    {{ t('info.En') }} /
                </label>
            </div>
            <div class="m-auto pe-2">
                <label class="p-2" style="cursor: pointer;" @click="$i18n.locale = 'es'">
                    <!-- <img src="../assets/Flag_of_Spain.svg" alt="Español"
                        style="width: 20px; vertical-align: middle; margin-right: 5px;"> -->
                    {{ t('info.Es') }}
                </label>
            </div>
            <div v-if="isLoggedIn" class="p-2" style="cursor: pointer;" data-bs-toggle="modal"
                data-bs-target="#modalMenu">
                <img alt="Menu" style="width: 40px; height: 100%" src="../assets/menu.svg">
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div v-if="LanguageSpanish" class="modal fade right-slide" data-bs-scroll="true" id="modalMenu" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content" :style="!showMore ? 'overflow: visible;' : ''">
                <div class="modal-body" :style="!showMore ? 'overflow-y: visible;' : ''">
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <router-link to="/dashboard" class="comfortaa-menu" v-html="t('menu.actividad')"></router-link>
                    </div>
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <router-link to="/audioteca" class="comfortaa-menu" v-html="t('menu.audioteca')"></router-link>
                    </div>
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <router-link to="/configuracion" class="comfortaa-menu" v-html="t('menu.audios')"></router-link>
                    </div>
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <router-link to="/perfil" class="comfortaa-menu" v-html="t('menu.perfil')"></router-link>
                    </div>
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <router-link to="/plan" class="comfortaa-menu" v-html="t('menu.pagos')"></router-link>
                    </div>
                    <div class="dv-menu" data-bs-dismiss="modal">
                        <a class="comfortaa-menu px-3" style="cursor: pointer;" v-html="t('menu.logout')"
                            @click="logout()"></a>
                    </div>
                    <!-- OPCIÓN GUÍA (SIEMPRE VISIBLE) -->
                    <div class="text-center mt-3 px-3" @click="toggleMore"
                        style="margin:15px; margin-bottom: 5px; cursor: pointer;">
                        <a class="comfortaa-menu" v-html="t('menu.guia')"></a>
                    </div>

                    <!-- BOTÓN DE DESPLIEGUE (ENTRE GUÍA Y SUB-OPCIONES) -->
                    <div class="d-flex justify-content-center"
                        style="position: relative; z-index: 10; margin-top: -5px; margin-bottom: -20px;">
                        <button class="btn shadow-sm" @click="toggleMore"
                            style="background-color: #fff; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; padding: 0;">
                            <img alt="AngerPulse logo mini"
                                :style="{ transform: showMore ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s ease', width: '24px', height: '24px' }"
                                src="../assets/arrow-down.svg">
                        </button>
                    </div>

                    <!-- SUB-OPCIONES -->
                    <div v-if="showMore" class="extra-options guia pb-4">
                         <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Faqs' }" class="comfortaa-menu"
                                v-html="t('faqs.title')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Ira' }" class="comfortaa-menu"
                                v-html="t('menu.ira')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Angerpulse' }" class="comfortaa-menu"
                                v-html="t('menu.angerpulse')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Quien' }" class="comfortaa-menu"
                                v-html="t('menu.para')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Como' }" class="comfortaa-menu"
                                v-html="t('menu.como')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Cuando' }" class="comfortaa-menu"
                                v-html="t('menu.cuando')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Dashboard' }" class="comfortaa-menu"
                                v-html="t('menu.actividad_guia')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Audioteca' }" class="comfortaa-menu"
                                v-html="t('menu.audioteca_guia')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Config' }" class="comfortaa-menu"
                                v-html="t('menu.audios_guia')"></router-link>
                        </div>
                        <div class="dv-menu" data-bs-dismiss="modal">
                            <router-link :to="{ path: '/info', hash: '#Tips' }" class="comfortaa-menu"
                                v-html="t('tips.title')"></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="content">
        <!-- Loader mientras valida expiración -->
        <div v-if="isCheckingExpiration" class="d-flex justify-content-center align-items-center" style="height: 60vh;">
            <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <!-- MENSAJE EXPIRO PLAN/PRUEBA -->
        <div v-else-if="isBlockedRoute"
            class="d-flex flex-column align-items-center justify-content-center text-center p-4 pt-5">
            <br><br><br><br>
            <h4 class="mb-4 b-24-black" style="max-width: 80%;">{{ t('expiration.' + expirationType) }}</h4>
            <button class="btn-black px-4 py-2 border-0 rounded-5" @click="$router.push('/plan')">{{
                t('expiration.btn_plan') }}</button>
        </div>

        <router-view v-else></router-view>
    </div>

</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { API_BASE_URL } from '@/config/api'

const router = useRouter()
const { t } = useI18n()
const route = useRoute()

const isLoggedIn = ref(false);
const showImage = ref(true)
const LanguageSpanish = ref(true)
const showMore = ref(false);

const isExpired = ref(false);
const expirationType = ref("");
const isCheckingExpiration = ref(false);

const isBlockedRoute = computed(() => {
    return isExpired.value && (route.path === '/homeplay' || route.path === '/audioteca');
});

async function checkUserExpiration() {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined') return;

    try {
        const response = await fetch(`${API_BASE_URL}/api/usuarios/GetUserInfo`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username: token })
        });
        if (response.ok) {
            const data = await response.json();
            if (data.data) {
                const user = typeof data.data === 'string' ? JSON.parse(data.data) : data.data;
                const idPlan = parseInt(user.IdPlan, 10);

                const finDateStr = user.Fin;
                if (!finDateStr) return;

                // Tratar safari bugs y formato DD/MM/YYYY
                const parts = finDateStr.split('/');
                let finDate;
                if (parts.length === 3) {
                    // Si el formato es DD/MM/YYYY
                    finDate = new Date(parts[2], parts[1] - 1, parts[0]);
                } else {
                    finDate = new Date(finDateStr.replace(/-/g, '/'));
                }

                const now = new Date();

                if (finDate < now) {
                    isExpired.value = true;
                    expirationType.value = idPlan === 4 ? 'trial_expired' : 'plan_expired';
                } else {
                    isExpired.value = false;
                    expirationType.value = "";
                }
            }
        }
    } catch (e) {
        console.error("Error fetching user expiration", e);
    }
}

const toggleMore = () => {
    showMore.value = !showMore.value
}

onMounted(() => {
    const token = localStorage.getItem('token')
    isLoggedIn.value = token !== null && token !== '' && token !== 'undefined'
});

watch(
    () => route.path,
    async (newPath) => {
        showImage.value = newPath !== '/home' && newPath !== '/';
        const token = localStorage.getItem('token');
        isLoggedIn.value = token !== null && token !== '' && token !== 'undefined';

        if (isLoggedIn.value && (newPath === '/homeplay' || newPath === '/audioteca')) {
            isCheckingExpiration.value = true;
            await checkUserExpiration();
            isCheckingExpiration.value = false;
        } else {
            isCheckingExpiration.value = false;
        }
    },
    { immediate: true }
)

const logout = () => {
    localStorage.removeItem('token')
    isLoggedIn.value = false;
    router.push('/login')
}

document.addEventListener("hidden.bs.modal", function (event) {
    if (event.target.id === "modalMenu") {
        showMore.value = false;
    }
});
</script>

<style scoped>
a {
    text-decoration: none;
    width: 100%;
    display: flex;
    justify-content: center;
}

.btn-circle {
    width: 25px;
    height: 45px;
    border-radius: 50%;
    border: none;
    background: #e0e0e0;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.btn-circle:hover {
    background: #d0d0d0;
}

.extra-options {
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.expiration-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 50;
    pointer-events: auto;
}

.blur-content {
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
}
</style>